// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"1e55fd64","58":"7817afdc","237":"a47213f2","245":"ccc28470","453":"b7370cb2","459":"9e12c85f","490":"8c13a4ae","733":"27b019e8","776":"7de0e03c","778":"e53e43f9","788":"d6749a1c","855":"7a7ac920","962":"b07ce81e"}[chunkId] + ".chunk.js";
};